// -----------------------------------
// undercontent_sidenavi.js
// -----------------------------------
(function() {
  const sideNavWrap = document.getElementById('under_content_side_nav');  // サイドナビWrapper
  const controller = document.getElementById('s_menu_controller');    // ボタンのWrapper
  const buttonOpen = document.getElementById('sidenavi_open_button');   // OPEN ボタン
  const forOpenElems = sideNavWrap.querySelectorAll('.for_open');
  let closeFlg = false;   // 2重クリック防止用

  // Handler
  // -----------------------------------

  // ボタンを表示
  window.addEventListener('scroll', controllerActivate);

  // OPEN クリック
  buttonOpen.addEventListener('click', openFunctions);

  // CLOSE クリック（ボタン系 or メニュー部分以外クリック）
  document.addEventListener('click', onClosestClick);

  // Functions
  // -----------------------------------

  // ボタン表示・非表示切り替え処理
  function controllerActivate() {
    let scroll = document.documentElement.scrollTop || document.body.scrollTop;   // スクロール量
    if(!document.getElementById('s_menu_main').classList.contains('is_show')) {
      if(scroll > document.getElementById('global_header').getBoundingClientRect().height * 3) {
        // ボタン出現
        controller.classList.add('active');
      } else {
        // メニューが閉じている状態ならボタンを非表示
        controller.classList.remove('active');
      }
    }
  }

  // メニュー部分以外をクリックで閉じる
  function onClosestClick(e) {
    e.stopPropagation();
    if(closest(e.target, '#sidenavi_open_button')) return false;
    if(!closest(e.target, '.s_slide_menu_inner')) {
      closeFunctions();
    }
  }

  // 開く処理
  function openFunctions() {
    // 開くボタン引っ込める
    controller.classList.remove('active');
    // コンテンツ出現
    g_Arr(forOpenElems).forEach(function(elem) {
      elem.classList.add('is_show');
    });

    // 閉じるボタンの動作を有効化
    setTimeout(function() {
      closeFlg = !closeFlg;
    }, 1000);
  }

  // 閉じる処理
  function closeFunctions() {
    if(!closeFlg) return false;
    
    let scroll = document.documentElement.scrollTop || document.body.scrollTop;   // スクロール量
    // クラス操作
    g_Arr(forOpenElems).forEach(function(elem) {
      elem.classList.remove('is_show');
    });
    if(scroll > document.getElementById('global_header').getBoundingClientRect().height * 3) {
      setTimeout(function() {
        // 開くボタン再出現
        controller.classList.add('active');
      }, 400);
    }

    // 閉じるボタンの動作を無効化
    closeFlg = !closeFlg;
  }

    // IE11用: closest
    function closest(node, selector) {
      return (node.closest || function(_selector) {
        do {
          // nodeとselectorがマッチしたら返す
          if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
            return node;
          }
          // マッチしなかったら親要素を代入
          node = node.parentElement || node.parentNode;
        } while (node !== null && node.nodeType === 1);
    
        return null;
      }).call(node, selector);
    }
})();